import React, { useState } from 'react';
import './App.css';

import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';

import LayoutView from './view/LayoutView';
import SectionView from './view/SectionView';
import ProductView from './view/ProductView';
import SearchView from './view/SearchView';

function SearchBar() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate(`/search?q=${encodeURIComponent(query)}`);
  };

  return (
    <div className="col-lg-5 col-md-5 search-block">
      <div className="advanced-search">
        <div className="input-group">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="O que você procura?"
              value={query}
              onChange={e => setQuery(e.target.value)}
            />
            <button type="submit"><i className="ti-search"></i></button>
          </form>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <header className="header-section">
          <Container>
            <div className="inner-header">
              <Row>
                <Col lg={4} md={4}>
                  <div className="logo">
                    <Row>
                      <Col>
                        <img src="/logo_v.png" alt="Adornos da Val"></img>
                      </Col>
                      <div className="brand-text">
                        <div className="brand-primary-text">
                          ADORNOS DA VAL
                        </div>
                        <div className="brand-second-text">
                          PRATAS E SEMIJÓIAS
                        </div>
                      </div>
                    </Row>
                  </div>
                </Col>

                <SearchBar />
              </Row>
            </div>
          </Container>
        </header>

        <Routes>
          <Route path="/" element={<LayoutView />}>
            <Route index element={<SectionView />} />
            <Route path="search" element={<SearchView />} />
            <Route path=":categoryPath" element={<SectionView />} />
            <Route path=":categoryPath/:productId" element={<ProductView />} />
          </Route>
        </Routes>

        <footer className="footer-section">
          <Container fluid="md">
            <Row className="justify-content-md-center">
              <div className="col-lg-2">
                <div className="footer-widget">
                  <span style={{ color: "gray" }}>
                    <i className="fa fa-instagram fa-3x"></i>
                  </span>
                  <a className="footer-link" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/adornos_da_val">Siga-nos</a>
                </div>
              </div>

              <div className="col-lg-2">
                <div className="footer-widget">
                  <span style={{ color: "gray" }}>
                    <i className="fa fa-whatsapp fa-3x"></i>
                  </span>
                  <a className="footer-link" target="_blank" rel="noopener noreferrer" href="https://wa.me/5511979997364">Whats</a>
                </div>
              </div>

              <div className="col-lg-2">
                <div className="footer-widget">
                  <span style={{ color: "gray" }}>
                    <i className="fa fa-exchange fa-3x"></i>
                  </span>
                  <a className="footer-link" href="/">Garantias e Trocas</a>
                </div>
              </div>
            </Row>
          </Container>
          <div className="copyright-reserved">
            <Container fluid>
              <Row>
                <Col>
                  <div className="copyright-text">
                    &copy; {new Date().getFullYear()} Adornos da Val - Todos os direitos reservados
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
